import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
  Box,
  Alert,
  CircularProgress,
} from '@mui/material';
import { AlertTriangle, Trash2 } from 'lucide-react';

import { rabbitmqApi } from '../../../../services/rabbitmqServices/rabbitmqService';

export const PurgeModal = ({
  isOpen = false,
  onClose = () => {},
  queueName = '',
  vhost = '/',
  onPurged = () => {},
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handlePurge = async () => {
    setLoading(true);
    setError('');
    try {
      await rabbitmqApi.purgeQueue(vhost, queueName);
      onPurged();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Error purging queue');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: '50%',
              bgcolor: 'rgba(239, 68, 68, 0.1)',
              color: '#ef4444',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <AlertTriangle style={{ width: 20, height: 20 }} />
          </Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
            Purge Queue Messages?
          </Typography>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.5 }}>
          Are you sure you want to purge all queued messages from{' '}
          <strong>{queueName}</strong>? All pending and unacknowledged messages will be permanently removed.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mt: 2, borderRadius: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2, pt: 1 }}>
        <Button onClick={onClose} disabled={loading} color="inherit">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handlePurge}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={14} color="inherit" /> : <Trash2 style={{ width: 14, height: 14 }} />}
        >
          {loading ? 'Purging...' : 'Purge All Messages'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
